import axios from "axios";

export const logout = async (postData) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng")
    const { data } = await axios.post(
      "/v1/admin/logout",
      postData,

      {headers: {Authorization: "Bearer " + `${brear}`,
    
      lang:lang}}   
    );
    return data;
  } catch (error) {
    
    throw error
  }
};
